/* Affy — product page: variants, gallery, sticky add-to-cart. */
(function () {
  'use strict';
  var doc = document;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var T = window.theme || {};

  function money(cents) {
    var v = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return (T.moneyFormat || 'AED {{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* ---- add-ons ("Make it extra special"): single-variant add-ons toggle on tap. Add-ons with
     multiple variants (Topper→design, Balloons→colour, Cake→flavour) open a picker; choosing a
     variant selects that add-on. Selected add-ons are added to the cart with the product on
     Add to cart — see cart.js. ---- */
  (function () {
    var modal = $('[data-addon-modal]'); if (!modal) return;
    var grid = $('[data-addon-modal-grid]', modal), titleEl = $('[data-addon-modal-title]', modal),
        subEl = $('[data-addon-modal-sub]', modal), priceEl = $('[data-addon-modal-price]', modal),
        addBtn = $('[data-addon-modal-add]', modal), removeBtn = $('[data-addon-modal-remove]', modal),
        fieldWrap = $('[data-addon-modal-field]', modal), fieldLabel = $('[data-addon-modal-fieldlabel]', modal),
        input = $('[data-addon-modal-input]', modal), panel = $('.pdp__addon-modal-panel', modal),
        introEl = $('[data-addon-modal-intro]', modal), orEl = $('[data-addon-modal-or]', modal),
        gridLabelEl = $('[data-addon-modal-gridlabel]', modal);
    var L_INTRO = modal.getAttribute('data-l-hybrid-intro') || '',
        L_WRITE = modal.getAttribute('data-l-write-own') || '',
        L_GRID = modal.getAttribute('data-l-grid-choose') || '',
        L_PLACEHOLDER = modal.getAttribute('data-l-placeholder') || '';
    function fill(tpl, token, val) { return (tpl || '').split(token).join((val || '').toLowerCase()); }
    var curCard = null, curVariant = null, curMode = 'variant', curLabel = '', curOption = '', curNumeric = false, customV = null, lastFocus = null;

    function hintEl(card) { return $('[data-addon-choose]', card); }
    function rememberHint(card) { var c = hintEl(card); if (c && !card.getAttribute('data-choose-initial')) card.setAttribute('data-choose-initial', c.textContent); }
    function restoreHint(card) { var i = card.getAttribute('data-choose-initial'), c = hintEl(card); if (c && i) c.textContent = i; }

    function cardImg(card) { return $('.pdp__addon-media img', card); }
    function setCardImage(card, src) {
      var img = cardImg(card); if (!img || !src) return;
      if (!card.getAttribute('data-img-initial')) card.setAttribute('data-img-initial', img.getAttribute('src') || '');
      img.src = src;
    }
    function restoreCardImage(card) { var init = card.getAttribute('data-img-initial'); if (!init) return; var img = cardImg(card); if (img) img.src = init; }
    function markSelected(card, id, hint, price) {
      if (id != null) card.setAttribute('data-addon-id', String(id));
      card.classList.add('is-selected'); card.setAttribute('aria-pressed', 'true');
      var p = $('[data-addon-price]', card); if (p && price) p.textContent = price;
      var c = hintEl(card); if (c && hint) c.textContent = hint;
    }
    function setVariant(card, v) { card.removeAttribute('data-addon-props'); setCardImage(card, v.image); var lbl = curLabel || curOption; markSelected(card, v.id, (lbl ? lbl + ': ' + v.title : v.title), v.price); }
    function setText(card, id, label, value, price) {
      var props = {}; props[label || 'Personalisation'] = value;
      card.setAttribute('data-addon-props', JSON.stringify(props));
      restoreCardImage(card);
      markSelected(card, id, (label ? label + ': ' + value : value), price);
    }
    function clearCard(card) {
      card.classList.remove('is-selected'); card.setAttribute('aria-pressed', 'false');
      card.removeAttribute('data-addon-props');
      if (card.hasAttribute('data-addon-has-options')) card.setAttribute('data-addon-id', '');
      restoreCardImage(card); restoreHint(card);
    }
    function updateAdd(selected) {
      if (!addBtn) return;
      var txt = input && input.value.trim();
      var ready = curMode === 'text' ? !!txt : curMode === 'hybrid' ? !!(txt || curVariant) : !!curVariant;
      addBtn.disabled = !ready;
      addBtn.textContent = selected ? (addBtn.getAttribute('data-label-update') || addBtn.textContent) : (addBtn.getAttribute('data-label-add') || addBtn.textContent);
    }
    function buildGrid(variants, already) {
      grid.innerHTML = '';
      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pdp__addon-opt'; b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', 'false');
        if (v.available === false) { b.disabled = true; b.classList.add('is-oos'); }
        b.innerHTML = '<span class="pdp__addon-opt-media">' + (v.image ? '<img src="' + v.image + '" alt="" width="120" height="120" loading="lazy">' : '') + '</span>' +
          '<span class="pdp__addon-opt-name">' + v.title + '</span><span class="pdp__addon-opt-price">' + v.price + '</span>';
        b.addEventListener('click', function () {
          if (v.available === false) return;
          $$('.pdp__addon-opt', grid).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
          b.classList.add('is-on'); b.setAttribute('aria-checked', 'true');
          curVariant = v; if (input) input.value = ''; if (priceEl) priceEl.textContent = v.price;
          updateAdd(curCard && curCard.classList.contains('is-selected'));
        });
        grid.appendChild(b);
        if (already && String(v.id) === String(already)) b.click();
      });
    }
    function open(card) {
      curCard = card; curVariant = null; customV = null; curOption = ''; lastFocus = document.activeElement;
      rememberHint(card);
      var hasOpts = card.hasAttribute('data-addon-has-options'), hasText = card.hasAttribute('data-addon-personalize');
      curMode = hasOpts && hasText ? 'hybrid' : (hasText ? 'text' : 'variant');
      curLabel = card.getAttribute('data-addon-label') || '';
      var already = card.getAttribute('data-addon-id'), selected = card.classList.contains('is-selected');
      var nameEl = $('.pdp__addon-name', card);
      if (titleEl) titleEl.textContent = nameEl ? nameEl.textContent : '';
      if (priceEl) priceEl.textContent = '';

      if (grid) { grid.hidden = !hasOpts; grid.innerHTML = ''; }
      if (hasOpts && grid) {
        var raw = $('[data-addon-json]', card), data = null;
        if (raw) { try { data = JSON.parse(raw.textContent); } catch (e) {} }
        if (data) {
          curOption = data.option || '';
          if (subEl) subEl.textContent = data.option;
          var variants = data.variants.slice();
          if (curMode === 'hybrid') {
            var ci = -1;
            for (var i = 0; i < variants.length; i++) { if (/custom|personalis|your own/i.test(variants[i].title)) { ci = i; break; } }
            if (ci >= 0) customV = variants.splice(ci, 1)[0]; else customV = data.variants[0];
          }
          buildGrid(variants, already);
        }
      }
      if (fieldWrap) {
        fieldWrap.hidden = !hasText;
        fieldWrap.classList.toggle('is-hybrid', curMode === 'hybrid');
        if (hasText) {
          if (fieldLabel) fieldLabel.textContent = (curMode === 'hybrid' && L_WRITE) ? fill(L_WRITE, '{label}', curLabel) : curLabel;
          if (subEl && curMode === 'text') subEl.textContent = curLabel;
          var existing = ''; var pr = card.getAttribute('data-addon-props');
          if (pr) { try { var o = JSON.parse(pr); existing = o[curLabel] || o[Object.keys(o)[0]] || ''; } catch (e) {} }
          curNumeric = card.hasAttribute('data-addon-numeric');
          if (input) {
            input.maxLength = parseInt(card.getAttribute('data-addon-max') || '60', 10) || 60;
            if (curNumeric) { input.inputMode = 'numeric'; input.setAttribute('pattern', '[0-9]*'); }
            else { input.inputMode = 'text'; input.removeAttribute('pattern'); }
            input.placeholder = L_PLACEHOLDER;
            input.value = existing;
          }
        }
      }
      /* hybrid: show the "write your own OR choose a preset" scaffolding */
      var isHybrid = curMode === 'hybrid';
      if (subEl) subEl.hidden = isHybrid;
      if (introEl) { introEl.hidden = !isHybrid; if (isHybrid) introEl.textContent = fill(L_INTRO, '{option}', curOption); }
      if (orEl) orEl.hidden = !isHybrid;
      if (gridLabelEl) { gridLabelEl.hidden = !isHybrid; if (isHybrid) gridLabelEl.textContent = fill(L_GRID, '{option}', curOption); }
      if (removeBtn) removeBtn.hidden = !selected;
      updateAdd(selected);
      modal.hidden = false; document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { modal.classList.add('is-open'); if (curMode === 'text' && input) input.focus(); else if (panel) panel.focus(); });
    }
    function close() {
      modal.classList.remove('is-open'); document.documentElement.style.overflow = '';
      setTimeout(function () { modal.hidden = true; }, 200);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      curCard = null; curVariant = null;
    }
    if (input) input.addEventListener('input', function () {
      if (curNumeric) { var d = input.value.replace(/[^0-9]/g, ''); if (d !== input.value) input.value = d; }
      if (input.value.trim() && grid) { $$('.pdp__addon-opt', grid).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); }); curVariant = null; }
      updateAdd(curCard && curCard.classList.contains('is-selected'));
    });
    $$('[data-addon-modal-close]', modal).forEach(function (b) { b.addEventListener('click', close); });
    if (addBtn) addBtn.addEventListener('click', function () {
      if (!curCard) return;
      var txt = input ? input.value.trim() : '';
      if (curMode === 'variant') { if (curVariant) { setVariant(curCard, curVariant); close(); } return; }
      if (curMode === 'text') { if (txt) { setText(curCard, curCard.getAttribute('data-addon-id'), curLabel, txt, null); close(); } return; }
      if (txt && customV) { setText(curCard, customV.id, curLabel, txt, customV.price); close(); }
      else if (curVariant) { setVariant(curCard, curVariant); close(); }
    });
    if (removeBtn) removeBtn.addEventListener('click', function () { if (curCard) { clearCard(curCard); close(); } });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Enter' && (curMode === 'text' || curMode === 'hybrid') && document.activeElement === input) { e.preventDefault(); if (addBtn && !addBtn.disabled) addBtn.click(); return; }
      if (e.key === 'Tab') { // simple focus trap
        var f = $$('button:not([disabled]), [href], input, [tabindex]:not([tabindex="-1"])', panel).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.__affyAddonOpen = open;
  })();

  $$('[data-addons]').forEach(function (wrap) {
    $$('[data-addon]', wrap).forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.hasAttribute('data-addon-has-options') || card.hasAttribute('data-addon-personalize')) { if (window.__affyAddonOpen) window.__affyAddonOpen(card); return; }
        var on = card.classList.toggle('is-selected');
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    var scroller = $('[data-addon-scroller]', wrap), row = $('[data-addon-row]', wrap);
    var prev = $('[data-addon-prev]', wrap), next = $('[data-addon-next]', wrap);
    if (scroller && row) {
      var update = function () { // rAF-coalesced: read all layout first, then write (no forced reflow)
        if (update._raf) return;
        update._raf = requestAnimationFrame(function () {
          update._raf = 0;
          var sw = row.scrollWidth, cw = row.clientWidth, sl = row.scrollLeft;
          scroller.classList.toggle('can-scroll', sw > cw + 4);
          if (prev) prev.disabled = sl <= 2;
          if (next) next.disabled = sl >= (sw - cw - 2);
        });
      };
      var nudge = function (dir) { row.scrollBy({ left: dir * Math.max(row.clientWidth * 0.8, 160), behavior: 'smooth' }); };
      if (prev) prev.addEventListener('click', function () { nudge(-1); });
      if (next) next.addEventListener('click', function () { nudge(1); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    }
  });

  $$('[data-product]').forEach(function (root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var product; try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('form[action*="/cart/add"]', root) || $('[data-product-form]', root);
    var idInput = form ? $('[name="id"]', form) : null;
    var priceWrap = $('[data-price-wrap]', root);
    var atcBtn = $('[data-atc]', root);
    var stickyPrice = $('[data-sticky-price]', root);

    function currentOptions() {
      return $$('[data-option-index]', root).map(function (group) {
        var checked = $('input:checked', group) || $('select', group);
        return checked ? checked.value : null;
      });
    }
    function findVariant(opts) {
      return (product.variants || []).filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      })[0];
    }
    function render(v) {
      if (!v) { if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = T.strings ? T.strings.unavailable || 'Unavailable' : 'Unavailable'; } return; }
      if (idInput) idInput.value = v.id;
      if (atcBtn) { atcBtn.disabled = !v.available; atcBtn.dataset.addLabel = atcBtn.dataset.addLabel || atcBtn.textContent; atcBtn.textContent = v.available ? (atcBtn.dataset.addLabel) : (T.strings ? T.strings.soldOut : 'Sold out'); }
      if (priceWrap) {
        var html = '<span class="now">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) html += ' <span class="was">' + money(v.compare_at_price) + '</span>';
        priceWrap.innerHTML = html;
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (v.featured_media && v.featured_media.id) {
        var main = $('[data-pdp-main] img', root) || $('[data-pdp-main]', root);
        var target = $$('[data-media-id]', root).filter(function (m) { return m.getAttribute('data-media-id') == v.featured_media.id; })[0];
        if (target && main && target.getAttribute('data-full')) {
          main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = target.getAttribute('data-full');
          // keep the gallery highlight in sync so prev/next arrows + swipe navigate from the shown photo
          $$('[data-pdp-thumb]', root).forEach(function (t) { t.classList.remove('on'); });
          if (target.classList.contains('pdp__thumb')) target.classList.add('on');
          var vimg = target.querySelector('img');
          if (vimg) main.setAttribute('alt', vimg.getAttribute('alt') || '');
          try { root.dispatchEvent(new CustomEvent('pdp:media')); } catch (e) {}
        }
      }
      try { var _u = new URL(location.href); _u.searchParams.set('variant', v.id); history.replaceState({}, '', _u); } catch (e) {} // preserve existing query params (UTM/ref); only update variant
    }
    $$('[data-option-index] input, [data-option-index] select', root).forEach(function (el) {
      el.addEventListener('change', function () {
        var opts = currentOptions();
        $$('[data-option-index]', root).forEach(function (g) { var lbl = $('[data-selected]', g); var c = $('input:checked', g) || $('select', g); if (lbl && c) lbl.textContent = c.value; });
        render(findVariant(opts));
      });
    });

    /* gallery: thumbnail click + prev/next arrows + mobile swipe */
    (function () {
      var main = $('[data-pdp-main] img', root);
      var stage = $('[data-pdp-main]', root);
      var thumbs = $$('[data-pdp-thumb]', root);
      if (!main || thumbs.length < 2) return;
      /* browsers prefer srcset over .src; Affy's main img has none today, but clear defensively */
      function setMainImage(url) { if (!url) return; main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = url; }
      function idx() { var on = thumbs.filter(function (t) { return t.classList.contains('on'); })[0]; var i = thumbs.indexOf(on); return i < 0 ? 0 : i; }
      function show(i) {
        i = (i % thumbs.length + thumbs.length) % thumbs.length;
        var t = thumbs[i], full = t.getAttribute('data-full');
        if (full) setMainImage(full);
        /* Carry the thumbnail's alt onto the main image. Swapping only .src left the main photo
           describing the FIRST image for the rest of the session - wrong for a screen reader, and
           wrong for the swatch sync below, which reads this alt to work out which colour is on
           screen. */
        var timg = t.querySelector('img');
        if (timg) main.setAttribute('alt', timg.getAttribute('alt') || '');
        thumbs.forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        try { t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) {}
        /* Announce it so the colour swatches can follow the photo. They are declared further down
           and cannot be called from here, so the sync goes through an event rather than a
           reference. */
        try { root.dispatchEvent(new CustomEvent('pdp:media')); } catch (e) {}
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prevBtn = $('[data-gallery-prev]', root), nextBtn = $('[data-gallery-next]', root);
      if (prevBtn) prevBtn.addEventListener('click', function () { show(idx() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(idx() + 1); });
      if (stage) {
        var x0 = null, y0 = null;
        stage.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) show(idx() + (dx < 0 ? 1 : -1));
          x0 = y0 = null;
        }, { passive: true });
      }
    })();

    /* Pick the gallery photo that best matches every colour the shopper has chosen.
       Box colour and flower colour are line-item properties rather than variants, so Shopify's
       own variant-image switching cannot do this.

       Matched on the FILENAME as well as the alt text. This started as alt-only, which meant it
       never once worked: all 177 photos on this shop have empty alt text, and so do all 462 on
       the other two. Filenames do carry the colour ("…-black-leather-box-mobile.jpg"), so reading
       both makes it work on the catalogue as it actually is, and better still once alts are added.

       SCORED, not first-match, and the same approach as the sibling Bloomistry theme. A photo
       scores once per chosen colour it satisfies, so with a black box and white flowers the shot
       tagged with both beats one tagged with either. A tie leaves the photo alone: showing the
       wrong colour is worse than showing none, because the shopper believes they have seen what
       they are buying. */
    function tokens(x) {
      return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean);
    }
    /* ALT TEXT ONLY, deliberately - not the filename. The filenames here describe the flowers:
       "affy-white-peony-leather-box-mobile.jpg" is a white peony in a black box, and matching on
       it would put a white swatch on a black box. The alt text says what the photo actually
       shows, so it is the only honest signal. */
    function thumbTokens(t) {
      var img = t.querySelector('img');
      return tokens(img && img.getAttribute('alt'));
    }
    function chosenColours() {
      var dims = [];
      $$('[data-box-sw].on, [data-flower-sw].on', root).forEach(function (sw) {
        var v = sw.getAttribute('data-box-val') || sw.getAttribute('data-flower-val') || '';
        if (v) dims.push(tokens(v));
      });
      return dims;
    }
    function swapByColour() {
      var dims = chosenColours();
      if (!dims.length) return;
      var thumbs = $$('[data-pdp-thumb]', root);
      if (!thumbs.length) return;
      var best = null, score = 0, tied = false;
      thumbs.forEach(function (t) {
        var toks = thumbTokens(t), sc = 0;
        dims.forEach(function (d) {
          if (d.every(function (tok) { return toks.indexOf(tok) > -1; })) sc++;
        });
        if (sc > score) { score = sc; best = t; tied = false; }
        else if (sc === score && sc > 0 && t !== best) { tied = true; }
      });
      if (!best || score === 0 || tied) return;
      var main = $('[data-pdp-main] img', root);
      var full = best.getAttribute('data-full');
      if (main && full) {
        main.removeAttribute('srcset'); main.removeAttribute('sizes');
        main.src = full;
        var bimg = best.querySelector('img');
        main.setAttribute('alt', (bimg && bimg.getAttribute('alt')) || '');
      }
      thumbs.forEach(function (t) { t.classList.remove('on'); });
      best.classList.add('on');
    }

    /* box-colour selector (line-item property) */
    var boxWrap = $('[data-box]', root);
    if (boxWrap) {
      var boxInput = $('[data-box-input]', boxWrap), boxName = $('[data-box-name]', boxWrap);
      $$('[data-box-sw]', boxWrap).forEach(function (sw) {
        sw.addEventListener('click', function () {
          $$('[data-box-sw]', boxWrap).forEach(function (s) { s.classList.remove('on'); });
          sw.classList.add('on');
          var val = sw.getAttribute('data-box-val') || '';
          if (boxInput) boxInput.value = val;
          if (boxName) boxName.textContent = val;
          swapByColour();
        });
      });
      /* Select the swatch matching the photo on screen, by its alt text.
         Runs on load AND on every gallery change: it used to run once, so picking a swatch moved
         the photo but moving the photo never moved the swatch, and the two drifted apart. The
         hidden input follows, so the property added to the cart is the colour actually shown. */
      var boxSwatches = $$('[data-box-sw]', boxWrap);
      function syncBoxToPhoto(useFallback) {
        var on = $$('[data-pdp-thumb].on', root)[0];
        var toks = on ? thumbTokens(on) : [];
        var match = boxSwatches.filter(function (s) {
          var d = tokens(s.getAttribute('data-box-val'));
          return d.length && d.every(function (t) { return toks.indexOf(t) > -1; });
        })[0];
        /* No match means this photo names no colour - every image on these shops has an empty
           alt today. Leave the shopper's choice alone rather than silently resetting it to the
           first swatch; only fall back on first load, when there is no choice to protect. */
        if (!match) {
          if (!useFallback) return;
          match = $('[data-box-sw].on', boxWrap) || boxSwatches[0];
          if (!match) return;
        }
        boxSwatches.forEach(function (s) { s.classList.remove('on'); });
        match.classList.add('on');
        var v = match.getAttribute('data-box-val') || '';
        if (boxInput) boxInput.value = v;
        if (boxName) boxName.textContent = v;
      }
      syncBoxToPhoto(true);
      root.addEventListener('pdp:media', function () { syncBoxToPhoto(false); });
    }

    /* flower-colour selector (line-item property) — mirrors the box handler; shown per-product via the custom.flower_colours metafield */
    var flowerWrap = $('[data-flowers]', root);
    if (flowerWrap) {
      var flowerInput = $('[data-flower-input]', flowerWrap), flowerName = $('[data-flower-name]', flowerWrap);
      $$('[data-flower-sw]', flowerWrap).forEach(function (sw) {
        sw.addEventListener('click', function () {
          $$('[data-flower-sw]', flowerWrap).forEach(function (s) { s.classList.remove('on'); });
          sw.classList.add('on');
          var val = sw.getAttribute('data-flower-val') || '';
          if (flowerInput) flowerInput.value = val;
          if (flowerName) flowerName.textContent = val;
          swapByColour();
        });
      });
      /* Same as the box swatches above: on load, and again on every gallery change. */
      var flSwatches = $$('[data-flower-sw]', flowerWrap);
      function syncFlowerToPhoto(useFallback) {
        var on = $$('[data-pdp-thumb].on', root)[0];
        var toks = on ? thumbTokens(on) : [];
        var match = flSwatches.filter(function (s) {
          var d = tokens(s.getAttribute('data-flower-val'));
          return d.length && d.every(function (t) { return toks.indexOf(t) > -1; });
        })[0];
        if (!match) {
          if (!useFallback) return;
          match = $('[data-flower-sw].on', flowerWrap) || flSwatches[0];
          if (!match) return;
        }
        flSwatches.forEach(function (s) { s.classList.remove('on'); });
        match.classList.add('on');
        var v = match.getAttribute('data-flower-val') || '';
        if (flowerInput) flowerInput.value = v;
        if (flowerName) flowerName.textContent = v;
      }
      syncFlowerToPhoto(true);
      root.addEventListener('pdp:media', function () { syncFlowerToPhoto(false); });
    }

    /* Message-card design picker + live message preview */
    var cardWrap = $('[data-carddesign]', root);
    if (cardWrap) {
      var cardInput = $('[data-card-input]', cardWrap);
      var cardPrev = $('[data-card-preview]', cardWrap);
      var cardPrevMsg = $('[data-card-preview-msg]', cardWrap);
      var giftMsg = $('[data-gift-msg]', root);
      function setCardBg(btn) {
        if (!cardPrev) return;
        var img = $('img', btn);
        if (img && img.getAttribute('src')) cardPrev.style.backgroundImage = 'url("' + img.getAttribute('src') + '")';
      }
      function selectCard(btn) {
        $$('[data-card-btn]', cardWrap).forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        if (cardInput) cardInput.value = btn.getAttribute('data-card-val') || '';
        setCardBg(btn);
      }
      $$('[data-card-btn]', cardWrap).forEach(function (b) { b.addEventListener('click', function () { selectCard(b); }); });
      var initCard = $('[data-card-btn].on', cardWrap) || $('[data-card-btn]', cardWrap);
      if (initCard) { if (cardInput) cardInput.value = initCard.getAttribute('data-card-val') || ''; setCardBg(initCard); }
      if (giftMsg && cardPrevMsg) {
        var syncMsg = function () { cardPrevMsg.textContent = giftMsg.value || ''; };
        giftMsg.addEventListener('input', syncMsg); syncMsg();
      }
    }

    /* sticky add-to-cart visibility */
    var sticky = $('[data-sticky-atc]', root);
    if (sticky && 'IntersectionObserver' in window && form) {
      var io = new IntersectionObserver(function (ents) { ents.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting); }); }, { rootMargin: '-80px 0px 0px 0px' });
      io.observe(form);
    }

    render(findVariant(currentOptions()));
  });

  /* ---- product recommendations (hydrate) ---- */
  $$('[data-product-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-product-recommendations], .pdp-related', parsed);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---- Reviews: add a real #reviews anchor above the Judge.me widget, plus a
     one-click "share for review" button (copies the product URL + #reviews) and a
     self-link. Works wherever the review widget sits in the page order. ---- */
  (function () {
    var S = T.strings || {};
    var TITLE = S.reviewsTitle || 'Customer Reviews',
        SHARE = S.reviewsShare || 'Share for review',
        COPIED = S.reviewsCopied || 'Review link copied',
        SELF = S.reviewsSelflink || 'Copy link to reviews';
    function widget() {
      return $('.jdgm-review-widget') || $('#judgeme_product_reviews') || $('.jdgm-rev-widg') || $('[id^="judgeme"]');
    }
    function reviewUrl() { return location.origin + location.pathname + '#reviews'; }
    function fallbackCopy(text) {
      var ta = doc.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'absolute'; ta.style.left = '-9999px'; doc.body.appendChild(ta);
      ta.select(); try { doc.execCommand('copy'); } catch (e) {} doc.body.removeChild(ta);
    }
    function copy(text, cb) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(cb, function () { fallbackCopy(text); cb(); });
      } else { fallbackCopy(text); cb(); }
    }
    /* Hide Judge.me's own "Customer Reviews" title so ours (with the Share button) is the
       only heading. Class-based first (safe, doc-wide); text-match fallback is scoped to the
       widget so it never hits our own heading; observed for async render. */
    var tries = 0;
    function init() {
      if (doc.getElementById('reviews')) return;
      var w = widget();
      if (!w) { if (tries++ < 40) setTimeout(init, 250); return; }

      var anchor = doc.createElement('span');
      anchor.id = 'reviews'; anchor.className = 'pdp__reviews-anchor';
      w.parentNode.insertBefore(anchor, w);

      /* Only the Share button — the widget keeps its own "Customer Reviews" heading (no duplicate). */
      var bar = doc.createElement('div'); bar.className = 'pdp__reviews-share';
      var btn = doc.createElement('button'); btn.type = 'button'; btn.className = 'pdp__reviews-sharebtn';
      var lbl = doc.createElement('span'); lbl.textContent = SHARE;
      btn.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>';
      btn.appendChild(lbl);
      /* transient confirmation lives OUTSIDE the button so the button label never
         changes — you can copy again immediately. */
      var status = doc.createElement('span'); status.className = 'pdp__reviews-status';
      status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      var actions = doc.createElement('div'); actions.className = 'pdp__reviews-actions';
      actions.appendChild(status); actions.appendChild(btn);
      bar.appendChild(actions);
      w.parentNode.insertBefore(bar, w);

      var reset;
      btn.addEventListener('click', function () {
        copy(reviewUrl(), function () {
          status.textContent = COPIED + ' ✓'; status.classList.add('is-show');
          clearTimeout(reset); reset = setTimeout(function () { status.classList.remove('is-show'); }, 1800);
        });
      });

      if (location.hash === '#reviews') {
        try { anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { anchor.scrollIntoView(); }
      }
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  })();
})();
